// =============================================
// StatusBadge — jeden wyglad statusow w module Cloudflare:
// zona (pending/active), akcje kreatora i wiersze Historii (success/ok/failed/skipped).
// =============================================
import { Badge } from "@/components/ui/badge";

export type CfStatusKind = "active" | "pending" | "ok" | "success" | "failed" | "skipped" | "running" | string;

const STYLE: Record<string, string> = {
  active: "border-emerald-500/40 text-emerald-400 bg-emerald-500/10",
  ok: "border-emerald-500/40 text-emerald-400 bg-emerald-500/10",
  success: "border-emerald-500/40 text-emerald-400 bg-emerald-500/10",
  pending: "border-amber-500/40 text-amber-400 bg-amber-500/10",
  running: "border-blue-500/40 text-blue-400 bg-blue-500/10",
  failed: "border-red-500/40 text-red-400 bg-red-500/10",
  skipped: "border-border text-muted-foreground bg-muted/20",
};

const LABEL: Record<string, string> = {
  active: "active", pending: "pending", ok: "OK", success: "OK", failed: "błąd", skipped: "pominięte", running: "w toku",
};

export const StatusBadge = ({ status, label, className = "" }: { status: CfStatusKind; label?: string; className?: string }) => (
  <Badge variant="outline" className={`${STYLE[status] ?? "border-border text-muted-foreground"} ${className}`}>
    {label ?? LABEL[status] ?? status}
  </Badge>
);
